<template>
	<AppDialog closeRight="-10" closeTop="-30" ref="dialog_container" :dialogName="'GmailWorkspaceSignupDialog'">
		<div class="content-container flex-column flex-centerize">
			<div class="title-text">This feature only works with</div>
			<div class="title-text mb-4">Google Workspace accounts (email@business.com)</div>
			<AnemicButton @click="replace" class="mt-9 replace-button">Use a different account</AnemicButton>
			<AnemicButton @click="continueWithRegular" class="mt-3 continue-button">Continue with this account</AnemicButton>
		</div>
	</AppDialog>
</template>

<script>
import AppDialog from '@/components/dialogs/AppDialog/AppDialog';

export default {
	name: 'GmailWorkspaceSignupDialog',
	props: {
		onReplace: { type: Function },
		onContinue: { type: Function },
	},
	components: {
		AppDialog,
	},
	methods: {
		close() {
			this.$refs.dialog_container.closeCurrentDialog();
		},
		replace() {
			this.onReplace();
			this.close();
		},
		continueWithRegular() {
			this.onContinue();
			this.close();
		},
	},
};
</script>

<style scoped lang="scss">
.content-container {
	width: 640px;
	height: 345px;
	overflow: hidden;
	border-radius: 10px;
	background: var(--bg-color);
	box-shadow: 0px 3px 6px var(--shadow-color);

	.title-text {
		font-size: 16px;
		font-weight: bold;
		color: var(--primary-font-color);
	}

	.replace-button {
		height: 45px;
		padding: 0px;
		width: 215px;
		font-size: 14px !important;
		color: var(--bg-color) !important;
		background: var(--bold-border-color);
		border: 1px solid var(--bold-border-color);
	}

	.continue-button {
		height: 45px;
		padding: 0px;
		width: 215px;
		font-size: 14px !important;
		color: var(--bold-border-color);
		background: var(--bg-color) !important;
		border: 1px solid var(--bold-border-color);
	}
}
</style>
